import Index from "../index";
import {GetStaticPaths, GetStaticProps} from 'next';

// Story pages are made on first request (a build can't reach the engine on Railway's private network); the page loads
// the story itself
export const getStaticPaths: GetStaticPaths = async () => {
    return {paths: [], fallback: 'blocking'};
};
// Get static props for each page
export const getStaticProps: GetStaticProps = async (context) => {
    const storyId = context.params?.storyId;
    return {
        props: {
            storyId,
        },
        revalidate: 1, // Revalidate every 1 second (adjust as needed)
    };
};

export default Index;
